import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useWebSocket } from "./hooks/useWebSocket";
import { TraceViewer } from "./components/TraceViewer";
import AgentChat from "./components/AgentChat";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./components/Login";
import { AppShell } from "./components/layout/AppShell";
import { LoadingState } from "./components/ui";
import HomePage from "./pages/HomePage";
import RunsPage from "./pages/RunsPage";
import EvaluationPage from "./pages/EvaluationPage";
import DatasetsPage from "./pages/DatasetsPage";
import DatabaseContextPage from "./pages/context/DatabaseContextPage";

function AppContent() {
  const state = useWebSocket();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <LoadingState label="Laden…" />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  const handleSelectRun = async (runId: string) => {
    if (runId === state.liveRunId) {
      await state.loadLiveRun();
    } else {
      await state.loadHistoricalRun(runId);
    }
    navigate("/runs");
  };

  const handleBackToLive = async () => {
    await state.loadLiveRun();
    navigate("/runs");
  };

  const activeTask = state.activeTraceView ? state.tasks[state.activeTraceView] : undefined;

  return (
    <AppShell liveRun={Boolean(state.liveRunId)}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/chat" element={<AgentChat />} />
        <Route path="/evaluaties" element={<EvaluationPage />} />
        <Route path="/runs" element={<RunsPage state={state} onSelectRun={handleSelectRun} onBackToLive={handleBackToLive} />} />
        <Route path="/vragenlijsten" element={<DatasetsPage />} />
        <Route path="/context" element={<DatabaseContextPage />} />
        {/* Old paths */}
        <Route path="/configuration" element={<Navigate to="/evaluaties" replace />} />
        <Route path="/dashboard" element={<Navigate to="/runs" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {state.activeTraceView && activeTask && (
        <TraceViewer
          questionId={state.activeTraceView}
          question={activeTask.question}
          traces={state.traces[state.activeTraceView] || []}
          sql={activeTask.sql}
          answer={activeTask.answer}
          evaluation={activeTask.evaluation}
          onClose={state.closeTraceViewer}
        />
      )}
    </AppShell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}
